import { api } from "../api/client";

/**
 * Tracking anónimo del portal de inicio (mascotas.vet): vistas de página,
 * clics en el menú de navegación y clics en botones de acción (CTAs). No se
 * guarda nada que identifique a la persona — solo un id aleatorio que vive
 * en su propio navegador (localStorage), para poder distinguir visitantes
 * únicos de vistas repetidas en las gráficas del super admin.
 *
 * Todo esto es "fire and forget": nunca debe interrumpir ni retrasar la
 * navegación del visitante, así que cualquier error de red se ignora en
 * silencio.
 */

const CLAVE_VISITANTE = "vetflow_visitante_id";

function idVisitante(): string {
  try {
    let id = localStorage.getItem(CLAVE_VISITANTE);
    if (!id) {
      id = `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(CLAVE_VISITANTE, id);
    }
    return id;
  } catch {
    // Navegación privada o localStorage bloqueado: se genera uno de un solo
    // uso para esta carga de página en vez de tronar.
    return `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
  }
}

function mandarEvento(tipo: "VISTA" | "NAVEGACION" | "CLIC", elemento?: string) {
  try {
    api
      .post("/analitica/evento", {
        tipo,
        ruta: window.location.pathname || "/",
        elemento,
        visitanteId: idVisitante(),
        referrer: document.referrer || undefined,
      })
      .catch(() => {});
  } catch {
    /* nunca debe afectar la experiencia del visitante */
  }
}

export function registrarVista() {
  mandarEvento("VISTA");
}

export function registrarNavegacion(elemento: string) {
  mandarEvento("NAVEGACION", elemento);
}

export function registrarClic(elemento: string) {
  mandarEvento("CLIC", elemento);
}
